/** Length of user-entered OTP (звонок с роботом, SMS, VK). */
export const OTP_CODE_LENGTH = 4;

export type OtpChannel = 'voice' | 'sms' | 'vk' | 'simpush';

export function isAppleOtpDevice(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  const platform = navigator.platform || '';
  const uaData = (navigator as Navigator & { userAgentData?: { platform?: string } })
    .userAgentData?.platform;
  const blob = `${ua} ${platform} ${uaData || ''}`;
  return /iPhone|iPad|iPod|Macintosh|Mac OS X|iOS|macOS/i.test(blob);
}

export function otpPlatform(): 'apple' | 'other' {
  return isAppleOtpDevice() ? 'apple' : 'other';
}

/** First code is a voice call. One SMS follows only if that call does not arrive. */
export function defaultOtpChannel(): OtpChannel {
  return 'voice';
}

export function nextOtpTimeoutChannel(channel: string | undefined): OtpChannel | null {
  if (channel === 'voice' || channel === 'flashcall') return 'sms';
  return null;
}
